import { render, staticRenderFns } from "./PDF.vue?vue&type=template&id=05708b12&scoped=true"
import script from "./PDF.vue?vue&type=script&lang=js"
export * from "./PDF.vue?vue&type=script&lang=js"
import style0 from "./PDF.vue?vue&type=style&index=0&id=05708b12&prod&lang=css"
import style1 from "./PDF.vue?vue&type=style&index=1&id=05708b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05708b12",
  null
  
)

export default component.exports